// Generated by GitHub Copilot
// Deep-merge API data over the template defaults + brand-colour derivation.

const isPlainObject = (v) => v !== null && typeof v === 'object' && !Array.isArray(v);

/**
 * Overlay `api` onto `def` using `def` as the schema:
 *  - arrays: use api array only when it is non-empty, else keep default
 *  - objects: merge key-by-key (api-only keys are also kept)
 *  - primitives: use api value unless it is null / undefined / ''
 */
export function mergeDashboard(def, api) {
  if (api === undefined || api === null) return def;
  if (Array.isArray(def)) return Array.isArray(api) && api.length ? api : def;
  if (isPlainObject(def)) {
    if (!isPlainObject(api)) return def;
    const out = { ...def };
    Object.keys(def).forEach((k) => { out[k] = mergeDashboard(def[k], api[k]); });
    Object.keys(api).forEach((k) => { if (!(k in out)) out[k] = api[k]; });
    return out;
  }
  return api === '' ? def : api;
}

const clamp = (n, lo, hi) => Math.max(lo, Math.min(hi, n));
const toHex = (c) => clamp(Math.round(c), 0, 255).toString(16).padStart(2, '0');

const parseHex = (hex) => {
  const h = String(hex || '').replace('#', '');
  if (h.length !== 6) return null;
  return [parseInt(h.slice(0, 2), 16), parseInt(h.slice(2, 4), 16), parseInt(h.slice(4, 6), 16)];
};

export function darken(hex, amount) {
  const rgb = parseHex(hex);
  if (!rgb) return hex;
  return '#' + rgb.map((c) => toHex(c * (1 - amount))).join('');
}

export function lighten(hex, amount) {
  const rgb = parseHex(hex);
  if (!rgb) return hex;
  return '#' + rgb.map((c) => toHex(c + (255 - c) * amount)).join('');
}

/** Build the inline CSS custom properties that re-theme the dashboard from company.brand. */
export function brandCssVars(brand = {}) {
  const primary = brand.primary_hex || '#2151A1';
  const accent = brand.accent_hex || '#E32934';
  return {
    '--p600': primary,
    '--p700': darken(primary, 0.2),
    '--p800': darken(primary, 0.4),
    '--p900': darken(primary, 0.6),
    '--p500': lighten(primary, 0.15),
    '--p400': lighten(primary, 0.3),
    '--p300': lighten(primary, 0.5),
    '--red': accent,
    '--red-dark': darken(accent, 0.25),
  };
}

/** Initials for the logo mark / chat avatar, mirroring the template. */
export function companyInitials(name) {
  const base = (name || 'GCC').replace(/[^A-Za-z0-9]/g, ' ').trim().split(/\s+/).slice(0, 2)
    .map((w) => w[0]).join('') || 'GC';
  return base.toUpperCase();
}
